import React from 'react';
import DS_ButtonLink from '../../DS_ButtonLink';
import { StyledButtonWrapper } from './EmbeddedEntryButtonStyles';

/**
 * Render embedded button in rich text
 *
 * @param {Boolean} isInternal
 * @param {Boolean} noFollow
 * @param {String} title
 * @param {String} url
 * @param {String} buttonVariant
 *
 * @returns {React.ReactElement}
 */
function EmbeddedEntryButton({ title, url, buttonVariant, noFollow }) {
  return (
    <StyledButtonWrapper>
      <DS_ButtonLink title={title} url={url} buttonVariant={buttonVariant} noFollow={noFollow}></DS_ButtonLink>
    </StyledButtonWrapper>
  );
}

export default EmbeddedEntryButton;
